import { render, staticRenderFns } from "./BoxInformationQuery.vue?vue&type=template&id=237249e5&scoped=true&"
import script from "./BoxInformationQuery.vue?vue&type=script&lang=js&"
export * from "./BoxInformationQuery.vue?vue&type=script&lang=js&"
import style0 from "./BoxInformationQuery.vue?vue&type=style&index=0&id=237249e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237249e5",
  null
  
)

export default component.exports